import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-bootstrap';
import { graphql } from 'react-apollo';
import chunk from 'lodash/chunk';
import LoadingIndicator from 'components/LoadingIndicator';
import { GET_GAMES_QUERY } from 'utils/graphql/queries';
import GameListPage from './GameListPage';
import './GameList.css';

class GameList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      index: 0,
      direction: null,
      carouselButtonsEnabled: true
    };
  }

  setActiveIndex(i, direction) {
    const gameChunks = this.getGamePages();
    let newIndex = i;
    newIndex = i > gameChunks.length - 1 ? 0 : newIndex;
    newIndex = i < 0 ? gameChunks.length - 1 : newIndex;

    this.setState({
      index: newIndex,
      carouselButtonsEnabled: false,
      direction
    });
    // Clear the automatic time switch.
    if (this.props.onInteraction) {
      this.props.onInteraction();
    }
  }

  enableCarouselButtons() {
    this.setState({
      carouselButtonsEnabled: true
    });
  }

  getGamePages() {
    if (!this.props.data.games || !this.props.data.games.games) {
      return [];
    }

    return chunk(this.props.data.games.games, 8);
  }

  render() {
    const { data } = this.props;
    const { carouselButtonsEnabled } = this.state;

    const gameChunks = !data.loading ? this.getGamePages() : [];
    const classNames = ['game-list', data.loading ? 'loading' : ''].join(' ');

    return (
      <div className={classNames}>
        {data.loading ? (
          <LoadingIndicator expand />
        ) : data.error ? (
          <div className="alert alert-danger">
            There was a problem retrieving the list of games. Please try again
            later.
          </div>
        ) : (
          data.games && (
            <div>
              <Carousel
                className="carousel"
                interval={null}
                indicators={false}
                activeIndex={this.state.index}
                direction={this.state.direction}
                onSlideEnd={() => this.enableCarouselButtons()}
              >
                {gameChunks.map((object, i) => {
                  return (
                    <Carousel.Item key={i}>
                      <GameListPage
                        games={object}
                        key={i}
                        onInteraction={this.props.onInteraction}
                      />
                    </Carousel.Item>
                  );
                })}
              </Carousel>
              <div className="pagination-container">
                <button
                  className="prev"
                  onClick={() =>
                    this.setActiveIndex(this.state.index - 1, 'prev')}
                  disabled={!carouselButtonsEnabled || this.state.index === 0}
                />
                {gameChunks.map((object, i) => (
                  <a
                    href="#"
                    className={i === this.state.index ? 'active' : ''}
                    key={i}
                    onClick={() =>
                      this.setActiveIndex(
                        i,
                        i > this.state.index ? 'next' : 'prev'
                      )}
                  >
                    {i + 1}
                  </a>
                ))}
                <button
                  className="next"
                  onClick={() =>
                    this.setActiveIndex(this.state.index + 1, 'next')}
                  disabled={
                    !carouselButtonsEnabled ||
                    this.state.index === gameChunks.length - 1
                  }
                />
              </div>
            </div>
          )
        )}
      </div>
    );
  }
}

GameList.propTypes = {
  onInteraction: PropTypes.func,
  data: PropTypes.shape({
    games: PropTypes.shape({
      games: PropTypes.arrayOf(PropTypes.object)
    }),
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.instanceOf(Error), PropTypes.bool])
  })
};

export default graphql(GET_GAMES_QUERY)(GameList);



// WEBPACK FOOTER //
// ./src/containers/GameList/index.js